module.exports = __webpack_public_path__ + "img/img_loto.3eb2216d.png";